import script from "./mv-file-record.vue?vue&type=script&setup=true&lang=js"
export * from "./mv-file-record.vue?vue&type=script&setup=true&lang=js"

import "./mv-file-record.vue?vue&type=style&index=0&id=0125a8e4&lang=css"

const __exports__ = script;

export default __exports__